import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsService {
  breadcrumbs = new BehaviorSubject<
    {
      label: string;
      label_en: string;
      path: string | null;
      type?: string | null;
    }[]
  >([]);
  constructor() {}

  setBreadcrumb(
    migajas: {
      label: string;
      label_en: string;
      path: string | null;
      type?: string | null;
    }[]
  ) {
    this.breadcrumbs.next(migajas);
  }
}
